var _desc, _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIllusGroups(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "187px",
    height: "187px",
    viewBox: "0 0 187 187",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "illus_empty_groups") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-50%",
    y: "-50%",
    width: "200%",
    height: "200%",
    filterUnits: "objectBoundingBox",
    id: "filter-1"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.26086957,
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "path-2",
    x: 0,
    y: 12.8731884,
    width: 64.6708333,
    height: 38.6195652
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-50%",
    y: "-50%",
    width: "200%",
    height: "200%",
    filterUnits: "objectBoundingBox",
    id: "filter-3"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0.290196078   0 0 0 0 0.6  0 0 0 0.1 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "-2.48949813e-15%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-4"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEF4FA",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "path-5",
    x: 0,
    y: 0,
    width: 64.6708333,
    height: 12.8731884,
    rx: 3.30434783
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-50%",
    y: "-50%",
    width: "200%",
    height: "200%",
    filterUnits: "objectBoundingBox",
    id: "filter-6"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0.290196078   0 0 0 0 0.6  0 0 0 0.1 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "114.573303%",
    x2: "50%",
    y2: "7.4636489%",
    id: "linearGradient-7"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEF4FA",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "path-8",
    cx: 13.6354167,
    cy: 2.72708333,
    r: 2.72708333
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-50%",
    y: "-50%",
    width: "200%",
    height: "200%",
    filterUnits: "objectBoundingBox",
    id: "filter-9"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0.290196078   0 0 0 0 0.6  0 0 0 0.07 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M13.2097207,5.93365385 L6.26734565,5.93365385 C5.42340652,5.93365385 4.6599587,6.43208077 4.32152935,7.20376006 L3.17940652,9.80909053 C2.93976196,10.3562038 3.19221196,10.9939956 3.74223587,11.229516 L3.83004457,11.2666393 C4.39958152,11.5100713 5.05631739,11.2264731 5.26791196,10.6458879 L6.09782609,8.36797337 L9.14673913,8.36797337 L7.3173913,12.6280325 L5.48804348,19.3224112 L1.07809565,19.3224112 C0.482947826,19.3224112 0,19.8037979 0,20.3983805 L0,21.2893414 C0,21.883924 0.482947826,22.3653107 1.07809565,22.3653107 L6.32954348,22.3653107 C7.11311413,22.3653107 7.81985217,21.8967041 8.1241337,21.1761456 L10.061413,16.5838018 L14.3433065,25.0960086 C14.521363,25.4721109 14.9006478,25.7125 15.3177391,25.7125 L16.619625,25.7125 C17.4038054,25.7125 17.9251696,24.9036973 17.6007652,24.1916589 L12.8054348,14.1494822 L14.3298913,9.88942308 L16.0098424,12.045013 C16.2964402,12.4132038 16.737313,12.6280325 17.2037967,12.6280325 L19.9594043,12.6280325 C20.555162,12.6280325 21.0375,12.1466459 21.0375,11.5520633 C21.0375,10.9580893 20.555162,10.4760941 19.9594043,10.4760941 L17.988587,10.4760941 L15.5634815,6.86234675 C15.1738304,6.28176154 13.9097511,5.93365385 13.2097207,5.93365385 Z",
    id: "path-10"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-50%",
    y: "-50%",
    width: "200%",
    height: "200%",
    filterUnits: "objectBoundingBox",
    id: "filter-11"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0.290196078   0 0 0 0 0.6  0 0 0 0.07 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("filter", {
    x: "-50%",
    y: "-50%",
    width: "200%",
    height: "200%",
    filterUnits: "objectBoundingBox",
    id: "filter-12"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.30434783,
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "path-13",
    x: 0,
    y: 9.82427536,
    width: 49.0875,
    height: 29.4728261
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-50%",
    y: "-50%",
    width: "200%",
    height: "200%",
    filterUnits: "objectBoundingBox",
    id: "filter-14"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0.290196078   0 0 0 0 0.6  0 0 0 0.1 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "path-15",
    x: 0,
    y: 0,
    width: 49.0875,
    height: 9.82427536,
    rx: 2.52173913
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-50%",
    y: "-50%",
    width: "200%",
    height: "200%",
    filterUnits: "objectBoundingBox",
    id: "filter-16"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0.290196078   0 0 0 0 0.6  0 0 0 0.1 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: "path-17",
    cx: 9.73958333,
    cy: 1.94791667,
    rx: 1.94791667,
    ry: 1.94791667
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-50%",
    y: "-50%",
    width: "200%",
    height: "200%",
    filterUnits: "objectBoundingBox",
    id: "filter-18"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0.290196078   0 0 0 0 0.6  0 0 0 0.07 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M9.78497826,4.31538462 L4.64247826,4.31538462 C4.01733816,4.31538462 3.45182126,4.67787692 3.20113285,5.23909822 L2.35511594,7.13388402 C2.17760145,7.53178462 2.36460145,7.99563314 2.77202657,8.16692071 L2.83707005,8.19391953 C3.25894928,8.37096095 3.74542029,8.16470769 3.902157,7.74246391 L4.51690821,6.08579882 L6.77536232,6.08579882 L5.42028986,9.18402367 L4.06521739,14.0526627 L0.798589372,14.0526627 C0.35773913,14.0526627 0,14.4027621 0,14.8351858 L0,15.4831574 C0,15.9155811 0.35773913,16.2656805 0.798589372,16.2656805 L4.68855072,16.2656805 C5.26897343,16.2656805 5.79248309,15.9248757 6.01787681,15.4008331 L7.45289855,12.0609467 L10.6246715,18.2516426 C10.7565652,18.5251716 11.0375169,18.7 11.3464734,18.7 L12.3108333,18.7 C12.8917077,18.7 13.2779034,18.1117799 13.0376039,17.5939337 L9.48550725,10.2905325 L10.6147343,7.19230769 L11.8591425,8.76000947 C12.0714372,9.02778462 12.3980097,9.18402367 12.7435531,9.18402367 L14.784744,9.18402367 C15.2260459,9.18402367 15.5833333,8.83392426 15.5833333,8.40150059 C15.5833333,7.96951953 15.2260459,7.61897751 14.784744,7.61897751 L13.3248792,7.61897751 L11.5285048,4.99079763 C11.2398744,4.56855385 10.3035193,4.31538462 9.78497826,4.31538462 Z",
    id: "path-19"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-50%",
    y: "-50%",
    width: "200%",
    height: "200%",
    filterUnits: "objectBoundingBox",
    id: "filter-20"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0.290196078   0 0 0 0 0.6  0 0 0 0.07 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("filter", {
    x: "-50%",
    y: "-50%",
    width: "200%",
    height: "200%",
    filterUnits: "objectBoundingBox",
    id: "filter-21"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10,
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "path-22",
    x: 0,
    y: 15.5833333,
    width: 77.9166667,
    height: 46.75
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-50%",
    y: "-50%",
    width: "200%",
    height: "200%",
    filterUnits: "objectBoundingBox",
    id: "filter-23"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0.290196078   0 0 0 0 0.6  0 0 0 0.1 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "path-24",
    x: 0,
    y: 0,
    width: 77.9166667,
    height: 15.5833333,
    rx: 4
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-50%",
    y: "-50%",
    width: "200%",
    height: "200%",
    filterUnits: "objectBoundingBox",
    id: "filter-25"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0.290196078   0 0 0 0 0.6  0 0 0 0.1 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: "path-26",
    cx: 16.3625,
    cy: 3.11666667,
    rx: 3.11666667,
    ry: 3.11666667
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-50%",
    y: "-50%",
    width: "200%",
    height: "200%",
    filterUnits: "objectBoundingBox",
    id: "filter-27"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0.290196078   0 0 0 0 0.6  0 0 0 0.07 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M15.6559652,7.0125 L7.42796522,7.0125 C6.42774106,7.0125 5.52291401,7.60155 5.12181256,8.51353462 L3.76818551,11.5925615 C3.48416232,12.23915 3.78336232,12.9929038 4.43524251,13.2712462 L4.53931208,13.3151192 C5.21431884,13.6028115 5.99267246,13.26765 6.24345121,12.5815038 L7.22705314,9.88942308 L10.8405797,9.88942308 L8.67246377,14.9240385 L6.50434783,22.8355769 L1.277743,22.8355769 C0.572382609,22.8355769 0,23.4044885 0,24.1071769 L0,25.1601308 C0,25.8628192 0.572382609,26.4317308 1.277743,26.4317308 L7.50168116,26.4317308 C8.43035749,26.4317308 9.26797295,25.8779231 9.6286029,25.0263538 L11.9246377,19.5990385 L16.9994744,29.6589192 C17.2105043,30.1034038 17.6600271,30.3875 18.1543575,30.3875 L19.6973333,30.3875 C20.6267324,30.3875 21.2446454,29.4316423 20.8601662,28.5901423 L15.1768116,16.7221154 L16.9835749,11.6875 L18.974628,14.2350154 C19.3142995,14.67015 19.8368155,14.9240385 20.389685,14.9240385 L23.6555903,14.9240385 C24.3616734,14.9240385 24.9333333,14.3551269 24.9333333,13.6524385 C24.9333333,12.9504692 24.3616734,12.3808385 23.6555903,12.3808385 L21.3198068,12.3808385 L18.4456077,8.11004615 C17.983799,7.4239 16.4856309,7.0125 15.6559652,7.0125 Z",
    id: "path-28"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-50%",
    y: "-50%",
    width: "200%",
    height: "200%",
    filterUnits: "objectBoundingBox",
    id: "filter-29"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0.290196078   0 0 0 0 0.6  0 0 0 0.07 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "CleverSparky-Web-App-UI",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groups-Empty",
    transform: "translate(-640.000000, -243.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "illus_empty_groups",
    transform: "translate(640.000000, 243.000000)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    id: "Oval-2",
    fill: "#EEF4FA",
    cx: 93.5,
    cy: 93.5,
    r: 93.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "illus_test_event",
    transform: "translate(29.608333, 40.516667)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Stroke-1",
    fillOpacity: 0.2,
    fill: "#004A99",
    filter: "url(#filter-1)",
    points: "6.46708333 59.2166667 58.20375 59.2166667 58.20375 43.1251812 6.46708333 43.1251812"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-3"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-3)",
    xlinkHref: "#path-2"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-3"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-6)",
    xlinkHref: "#path-5"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#linearGradient-4)",
    fillRule: "evenodd",
    xlinkHref: "#path-5"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-4",
    fill: "url(#linearGradient-7)",
    x: 6.46708333,
    y: 19.3097826,
    width: 25.8683333,
    height: 25.7463768,
    rx: 1.65217391
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.20309,34.1139493 L40.4624296,34.1139493 C39.5456758,34.1139493 38.8025,33.3761837 38.8025,32.4563422 L38.8025,30.6222809 C38.8025,29.7068099 39.5474047,28.9646739 40.4624296,28.9646739 L48.5550001,28.9646739 L44.7494053,25.1770207 C44.1407715,24.5712562 44.1398321,23.590053 44.7513086,22.9814593 L45.48563,22.2505998 C46.095315,21.6437892 47.0862395,21.6462075 47.6915914,22.2487056 L54.7282297,29.2521696 C54.8428809,29.3183011 54.9508559,29.4001685 55.0489598,29.4978099 L55.7832813,30.2286695 C56.098433,30.5423353 56.2509076,30.9549781 56.2413517,31.3641861 C56.2509076,31.7733941 56.098433,32.1860368 55.7832813,32.4997027 L55.0489598,33.2305622 C54.9508559,33.3282036 54.8428809,33.4100711 54.7282297,33.4762026 L47.6915914,40.4796666 C47.0862395,41.0821646 46.095315,41.0845829 45.48563,40.4777723 L44.7513086,39.7469128 C44.1398321,39.1383191 44.1407715,38.1571159 44.7494053,37.5513515 L48.20309,34.1139493 Z",
    id: "Combined-Shape",
    fill: "url(#linearGradient-7)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "man",
    transform: "translate(10.129167, 20.258333)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Oval-3"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-9)",
    xlinkHref: "#path-8"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Page-1"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-11)",
    xlinkHref: "#path-10"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-10"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "illus_test_event",
    transform: "translate(46.750000, 105.966667)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Stroke-1",
    fillOpacity: 0.2,
    fill: "#004A99",
    filter: "url(#filter-12)",
    points: "4.90875 45.1916667 44.17875 45.1916667 44.17875 32.9113225 4.90875 32.9113225"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-3"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-14)",
    xlinkHref: "#path-13"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-13"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-3"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-16)",
    xlinkHref: "#path-15"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#linearGradient-4)",
    fillRule: "evenodd",
    xlinkHref: "#path-15"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-4",
    fill: "url(#linearGradient-7)",
    x: 4.90875,
    y: 14.736413,
    width: 19.635,
    height: 19.6485507,
    rx: 1.26086957
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.5878876,26.0343297 L30.7124465,26.0343297 C30.0165973,26.0343297 29.4525,25.4712981 29.4525,24.7693138 L29.4525,23.3696355 C29.4525,22.6709865 30.0179096,22.1046196 30.7124465,22.1046196 L36.8550001,22.1046196 L33.9664161,19.2140421 C33.504441,18.7517482 33.503728,18.0029352 33.9678607,17.5384821 L34.5252373,16.9807209 C34.9880102,16.5176286 35.7401577,16.5194742 36.1996417,16.9792753 L41.5407045,22.3240241 C41.6277289,22.3744929 41.7096858,22.4369707 41.7841502,22.5114865 L42.3415268,23.0692477 C42.5807383,23.3086243 42.6964721,23.6235359 42.6892188,23.9358262 C42.6964721,24.2481165 42.5807383,24.5630281 42.3415268,24.8024047 L41.7841502,25.3601659 C41.7096858,25.4346817 41.6277289,25.4971595 41.5407045,25.5476283 L36.1996417,30.8923771 C35.7401577,31.3521782 34.9880102,31.3540238 34.5252373,30.8909315 L33.9678607,30.3331703 C33.503728,29.8687172 33.504441,29.1199042 33.9664161,28.6576103 L36.5878876,26.0343297 Z",
    id: "Combined-Shape",
    fill: "url(#linearGradient-7)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "man",
    transform: "translate(7.791667, 15.583333)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Oval-3"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-18)",
    xlinkHref: "#path-17"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-17"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Page-1"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-20)",
    xlinkHref: "#path-19"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-19"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "illus_test_event",
    transform: "translate(81.812500, 65.450000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Stroke-1",
    fillOpacity: 0.2,
    fill: "#004A99",
    filter: "url(#filter-21)",
    points: "7.79166667 71.6833333 70.125 71.6833333 70.125 52.2041667 7.79166667 52.2041667"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-3"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-23)",
    xlinkHref: "#path-22"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-22"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-3"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-25)",
    xlinkHref: "#path-24"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#linearGradient-4)",
    fillRule: "evenodd",
    xlinkHref: "#path-24"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-4",
    fill: "url(#linearGradient-7)",
    x: 7.79166667,
    y: 23.375,
    width: 31.1666667,
    height: 31.1666667,
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.076012,41.2958333 L48.7499151,41.2958333 C47.6453925,41.2958333 46.75,40.4027486 46.75,39.2892564 L46.75,37.0690769 C46.75,35.9608751 47.6474756,35.0625 48.7499151,35.0625 L58.5000001,35.0625 L53.9149462,30.4774461 C53.1816524,29.7441523 53.1805206,28.55638 53.9172392,27.8196613 L54.8019639,26.9349366 C55.5365241,26.2003764 56.730409,26.2033039 57.4597487,26.9326436 L65.9376262,35.4105211 C66.0757601,35.490575 66.2058504,35.5896777 66.324048,35.7078752 L67.2087726,36.5925999 C67.5884735,36.9723007 67.7721779,37.4718156 67.7606647,37.9671726 C67.7721779,38.4625296 67.5884735,38.9620445 67.2087726,39.3417453 L66.324048,40.22647 C66.2058504,40.3446676 66.0757601,40.4437702 65.9376262,40.5238242 L57.4597487,49.0017016 C56.730409,49.7310413 55.5365241,49.7339688 54.8019639,48.9994086 L53.9172392,48.1146839 C53.1805206,47.3779653 53.1816524,46.1901929 53.9149462,45.4568992 L58.076012,41.2958333 Z",
    id: "Combined-Shape",
    fill: "url(#linearGradient-7)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "man",
    transform: "translate(12.466667, 24.933333)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Oval-3"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-27)",
    xlinkHref: "#path-26"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-26"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Page-1"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-29)",
    xlinkHref: "#path-28"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-28"
  }))))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllusGroups);
export default __webpack_public_path__ + "static/media/illus-groups.1746f2725b977e346e801c7ea84fe145.svg";
export { ForwardRef as ReactComponent };